import { useAccount } from '@ltvco/refresh-lib/v1';

import { Astrology } from 'components/Astrology';

export const AstrologyPage = () => {
  const { data: account } = useAccount(true);
  const memberId = account?.account.user_info?.user_code || '';

  return <Astrology identifier={memberId} enableOnboarding standaloneVersion />;
};
